import { React, useState } from "react";
import "./Search.css";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import DataTable from "./components/DataTable";
import ViewDataset from "./components/ViewDataset";
import LinearProgress from "@material-ui/core/LinearProgress";
import PrimaryButton from "../../../../components/PrimaryButton";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  searchBar: {
    width: "70%",
    backgroundColor: "white",
    marginLeft: "3%",
    marginTop: "2%",
  },
  formControl: {
    margin: theme.spacing(1),
    marginLeft: "3%",
    marginTop: "2%",
    minWidth: 120,
    backgroundColor: "white",
    width: "15%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  nextButton: {
    float: "right",
    marginRight: "8%",
    marginTop: "2%",
  },
  dbLabel: {
    marginLeft: "3%",
  },
  results: {
    marginTop: "2%",
    height: "60%",
    overflow: "scroll",
  },
}));

const Search = (props) => {
  const classes = useStyles();
  const [sort, setSort] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [showDatasets, setShowDatasets] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedRowsCount, setSelectedRowsCount] = useState(0);

  const handleChange = (event) => {
    setSort(event.target.value);
  };

  const handleRowSelected = (e) => {
    props.onSelect(e);
    console.log(props.rows);
    setSelectedRowsCount(props.rows.length);
  };
  const handleInputChange = (event) => {
    setSearchInput(event.target.value);
    if (searchInput.length > 4) {
      setLoading(true);
      setTimeout(function () {
        setLoading(false);
        setShowDatasets(true);
      }, 1000);
    } else {
      setShowDatasets(false);
    }
  };
  return (
    <>
      <div>
        <TextField
          id="outlined-basic"
          label="Search datasets..."
          variant="outlined"
          className={classes.searchBar}
          onChange={handleInputChange}
        />
        <FormControl variant="outlined" className={classes.formControl}>
          <InputLabel id="demo-simple-select-outlined-label">
            Sort By
          </InputLabel>
          <Select
            labelId="demo-simple-select-outlined-label"
            id="demo-simple-select-outlined"
            value={sort}
            onChange={handleChange}
            label="Sort By"
          >
            <MenuItem value={10}>Date</MenuItem>
            <MenuItem value={20}>Alphabetical</MenuItem>
            <MenuItem value={30}>Usage</MenuItem>
          </Select>
        </FormControl>
      </div>
      <label className={classes.dbLabel}>
        You are searching in:{" "}
        <span style={{ fontWeight: "bold" }}>
          {sessionStorage.getItem("db")}
        </span>
      </label>

      <div className={classes.results}>
        {loading && <LinearProgress />}
        {showDatasets && <DataTable onRowSelected={handleRowSelected} />}
      </div>

      <Link to="/methods/new-method/features">
        <PrimaryButton
          innerText="Next"
          isDisabled={selectedRowsCount === 0}
          styleClasses={classes.nextButton}
        />
      </Link>

      <ViewDataset isButtonDisabled={selectedRowsCount === 0} />
    </>
  );
};

export default Search;
